export function linear(t) {
  return +t;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-ease@1.0.6@d3-ease/src/linear.js
// module id = 199
// module chunks = 0 1 2